<template>
    <div class="d-card">
        <header v-if="title || titleRight || hasTitleRightSlot">
            <span>{{ title }}</span>
            <span v-if="hasTitleRightSlot">
                <slot name="title-right" />
            </span>
            <span v-else-if="titleRight">{{ titleRight }}</span>
        </header>
        <main :class="padding ? 'padding' : ''">
            <slot />
        </main>
        <footer
            v-if="hasFooterSlot"
            :class="footerPadding ? 'padding' : ''"
        >
            <slot name="footer" />
        </footer>
    </div>
</template>

<script>
export default {
    name: 'DCard',
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        titleRight: {
            type: String,
            required: false,
            default: ''
        },
        padding: {
            type: Boolean,
            required: false,
            default: false
        },
        footerPadding: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hasFooterSlot () {
            return !!this.$slots.footer
        },
        hasTitleRightSlot () {
            return !!this.$slots['title-right']
        }
    }
}
</script>

<style lang="scss" scoped>
.d-card {
    background: var(--colorAppSurface);
    border-radius: 5px;
    border: 1px solid var(--colorAppBorder);

    & header {
        padding: 10px 15px;
        border-bottom: 1px solid var(--colorAppBorder);
        display: flex;
        justify-content: space-between;
    }

    & main {
        &.padding {
            padding: 15px;
        }
    }
    & footer {
        border-top: 1px solid var(--colorAppBorder);

        &.padding {
            padding: 15px;
        }
    }
}
</style>
